import apiClient from './client';
import { endpoints } from './endpoints';
import type { Appointment } from '@/types';

export const appointmentService = {
  async list(filters: Record<string, unknown> = {}): Promise<Appointment[] | unknown> {
    const response = await apiClient.get(endpoints.appointments.list, { params: filters });
    return response.data;
  },
  async get(id: string): Promise<Appointment | unknown> {
    const response = await apiClient.get(endpoints.appointments.get(id));
    return response.data;
  },
  async create(appointmentData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.post(endpoints.appointments.create, appointmentData);
    return response.data;
  },
  async update(id: string, appointmentData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.put(endpoints.appointments.update(id), appointmentData);
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.appointments.delete(id));
    return response.data;
  },
};

export default appointmentService;
